<template>
  <div class="content">
    <el-row class="bgW">
      <el-col :span="22">
        <!--检索条件-->
        <el-form class="search" :inline="true" label-suffix="：" size="mini" :model="search">
          <el-form-item label="成交日期">
            <el-date-picker
              v-model="value1"
              type="daterange"
              range-separator="至"
              class="w220"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="searchTime"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="客户名称" v-if="!clienId">
            <el-input
              v-model="search.consignee"
              maxlength="30"
              class="w84"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
          
          <el-form-item label="手机号" v-if="!clienId">
            <el-input
              class="w120"
              v-model="search.telephone"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
          <el-form-item label="门店名称" v-if="!clienId">
            <el-input
              v-model="search.shop_name"
              maxlength="30"
              class="w84"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
          <el-form-item size="mini" label="护理师(开单人)" prop="sale_id">
            <el-select v-model="search.sale_id" clearable remote filterable placeholder="请选择" class="w140">
              <el-option
                v-for="item in options.staff"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="商品/项目/品项名称">
            <el-select v-model="search.type" @change="handleTypeChange" clearable class="w100">
              <el-option
                v-for="item in options.typeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
            <el-select
              v-model="search.kingdee_code"
              clearable
              filterable
              placeholder="请输入"
              class="w220"
              remote
              :remote-method="remoteMethodGoods"
            >
              <el-option
                v-for="item in options.goodsList"
                :key="item.kingdee_code"
                :label="item.name"
                :value="item.kingdee_code"
              >
                <span>{{ item.name }}</span>
                <span style="color: #8492a6; font-size: 13px" v-if="item.spec_name">-{{ item.spec_name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销售金额">
            <el-input
              v-model="search.low_total"
              maxlength="30"
              class="w84"
              placeholder="最小值"
              clearable
            />
            <span></span>
            <el-input
              v-model="search.large_total"
              maxlength="30"
              class="w84"
              placeholder="最大值"
              clearable
            />
          </el-form-item>
          <el-form-item label="业务类型">
            <el-select v-model="search.business_type" placeholder="请选业务类型" class="w120" clearable>
              <el-option
                v-for="item in options.business_type"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="订单类型">
            <el-select v-model="search.order_type" placeholder="请选订单类型" class="w120" clearable>
              <el-option
                v-for="item in options.order_type"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="订单来源">
            <el-select v-model="search.is_app" placeholder="请选订单来源" class="w120" clearable>
              <el-option
                v-for="item in options.is_app_List"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="订单状态">
            <el-select v-model="search.status" placeholder="请选订单状态" class="w120" clearable>
              <el-option
                v-for="item in options.display_cannel"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="品项类目选择">
            <el-cascader
              v-model="search.typepx"
              clearable
              :options="options.pxTypeList"
              :props="{ checkStrictly: true }"
            />
          </el-form-item>
          <el-form-item label="所属病历ID">
            <el-input v-model="search.medical_id" placeholder="请输入所属病历ID" clearable class="w220" />
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="2" style="text-align: right">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
      </el-col>
    </el-row>
    <div class="accountCon">
      <div class="btnBox">
        <el-button
          v-loading.fullscreen.lock="fullscreenLoading"
          type="primary"
          class="mb10"
          size="mini"
          @click="tapDetail('export')"
        >导出数据</el-button>
        <div v-if="userInfo.shop_id"></div>
        <el-button v-if="!clienId" type="primary" class="mb10" size="mini" @click="tapDetail('lock')">锁定订单</el-button>
        <span >
          <!-- v-if="is_show_add  && (detail.shop_type == 1 || detail.shop_type == 3)" -->
          <el-button
            v-if="clienId && oldId == clienId"
            type="primary"
            class="mb10"
            round
            size="mini"
            @click="tapDetail('add')"
          >添加销售出库单</el-button>
        </span>
      </div>
      <el-row>
        <el-col :span="24">
          <el-table
            v-loading="table_loading"
            :data="flatList"
            size="small"
            border
            :cell-style="$style.cellStyle"
            :header-cell-style="$style.rowClass"
            @selection-change="handleSelectionChange"
            row-key="_rowKey"
            :span-method="spanMethod"
          >
            <!-- 0. 订单编号 -->
            <ElTableColumn label="订单编号" prop="order_no" width="170" fixed="left">
              <template slot-scope="{ row }">
                <span>{{ row.order_no }}<span style="color: red;" v-if="row.data_business_type == '药'">（{{ row.data_business_type }}）</span></span>
              </template>
            </ElTableColumn>
            
            <!-- 1. 成交日期 -->
            <ElTableColumn label="成交日期" prop="deal_time" width="90" fixed="left" />
            
            <!-- 2. 客户名称 -->
            <ElTableColumn label="客户名称" prop="consignee" fixed="left" />
            
            <!-- 3. 手机号 -->
            <ElTableColumn label="手机号" prop="telephone" width="95" />
            
            <!-- 4. 客户K3代码 -->
            <ElTableColumn label="客户K3代码" prop="king_no" width="90" />
            
            <!-- 5. 门店 -->
            <ElTableColumn label="门店" prop="shop_name" />
            
            <!-- 6. 开单人 -->
            <ElTableColumn label="开单人" prop="sale_name" />
            
            <!-- 7. 订单来源 -->
            <ElTableColumn label="订单来源" prop="is_app_msg" />
            
            
            <!-- 9. 订单类型 -->
            <ElTableColumn label="订单类型" prop="order_type" />
            
            <!-- 10. 标准单价 -->
            <ElTableColumn label="标准单价" prop="goods_price" />
            
            <!-- 11. 标准金额 -->
            <ElTableColumn label="标准金额">
              <template slot-scope="{ row }">
                <span>{{ row.goods_price && row.number ? (Number(row.goods_price) * Number(row.number)).toFixed(2) : '-' }}</span>
              </template>
            </ElTableColumn>
            
            <!-- 12. 销售金额 -->
            <ElTableColumn label="销售金额">
              <template slot-scope="{ row }">
                <span>{{ row.after_discount_total || row.order_amount || '-' }}</span>
              </template>
            </ElTableColumn>
            
            <!-- 13. 实付金额 -->
            <ElTableColumn label="实付金额">
              <template slot-scope="{ row }">
                <span>{{ row.after_discount_amount || '-' }}</span>
              </template>
            </ElTableColumn>
            
            <!-- 14. 优惠后本金 -->
            <ElTableColumn label="优惠后本金">
              <template slot-scope="{ row }">
                <span>{{ row.pay_amount || '-' }}</span>
              </template>
            </ElTableColumn>
            
            <!-- 15. 优惠后赠金 -->
            <ElTableColumn label="优惠后赠金">
              <template slot-scope="{ row }">
                <span>{{ row.gift_amount || '-' }}</span>
              </template>
            </ElTableColumn>
            
            <!-- 16. 优惠后店转 -->
            <ElTableColumn label="优惠后店转">
              <template slot-scope="{ row }">
                <span>{{ row.shop_transfer_amount || '-' }}</span>
              </template>
            </ElTableColumn>
            
            <!-- 19. 订单状态 -->
            <ElTableColumn label="订单状态" prop="status_msg" />
            
            <!-- 20. 所属病历ID -->
            <ElTableColumn label="所属病历ID" prop="medical_id" />
            
            <!-- 22. 商品名称 -->
            <ElTableColumn label="商品名称" width="200">
              <template slot-scope="{ row }">
                <span>{{ row.goods_name || '-' }}<span style="color: red;" v-if="row.data_business_type == '药'">（{{ row.data_business_type }}）</span></span>
              </template>
            </ElTableColumn>

            <!-- 25. 别名 -->
            <ElTableColumn label="别名"  width="120">
              <template slot-scope="{ row }">
                <span>{{ row.goods_alias_name || '-' }}</span>
              </template>
            </ElTableColumn>
            
            <ElTableColumn label="是否存货">
              <template slot-scope="{ row }">
                <span>{{row.prestock_type}}{{ row.takeout_stock_num || '-' }}</span>
              </template>
            </ElTableColumn>
            <!-- 8. 业务类型 -->
            <ElTableColumn label="业务类型">
              <template slot-scope="{ row }">
                <div>{{ row.business_type }}</div>
              </template>
            </ElTableColumn>
            <!-- 23. 销售单价 -->
            <ElTableColumn label="销售单价" prop="pay_price" />
             <!-- 14. 优惠后本金 -->
            <ElTableColumn label="优惠后本金">
              <template slot-scope="{ row }">
                <span>{{ row.pay_amount1 || '-' }}</span>
              </template>
            </ElTableColumn>
            
            <!-- 15. 优惠后赠金 -->
            <ElTableColumn label="优惠后赠金">
              <template slot-scope="{ row }">
                <span>{{ row.gift_amount1|| '-' }}</span>
              </template>
            </ElTableColumn>
            
            <!-- 16. 优惠后店转 -->
            <ElTableColumn label="优惠后店转">
              <template slot-scope="{ row }">
                <span>{{ row.shop_transfer_amount1 || '-' }}</span>
              </template>
            </ElTableColumn>
            
            <!-- 24. 数量 -->
            <ElTableColumn label="数量" prop="number" />
            
            
            <!-- 26. 品项一级 -->
            <ElTableColumn label="品项" prop="type_one_name" >
              <template slot-scope="{ row }">
                <span>
                  {{ row.type_one_name ? row.type_one_name + '/' : '' }}
                  {{ row.type_two_name ? row.type_two_name + '/' : '' }}
                  {{ row.type_three_name || '-' }}
                </span>
              </template>
            </ElTableColumn>
            <!-- 29. 操作 -->
            <ElTableColumn label="操作" fixed="right" width="70" v-if="oldId == clienId">
              <template slot-scope="{ row }">
                <span class="theme" v-if="clienId && row.goods_list" @click="tapDetail('销售记录详情', row)">查看</span>
                <span class="theme" v-if="!clienId && row.goods_list" @click="tapDetail('销售出库单详情', row)">查看</span>
              </template>
            </ElTableColumn>
          </el-table>
          <div class="reveal" v-if="sum_amount != 'noShow'">
            <span class="mr20">
              销售金额合计：
              <span class="peril">{{ sum_amount }}</span>
            </span>
          </div>
          <pagination
            class="page tc mt10"
            :total="page.total"
            :page.sync="page.page"
            :limit.sync="page.limit"
            @pagination="getList"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import dateMixin from '@/mixins/dateMixin';
import { goodsList2, getGoodsAndItem, getGoodList, getProductTypeParent } from '@/api/goods'
import { searchPersonList } from '@/api/staff'
import pagination from "@/components/Pagination";
import { orderList, exportOrder, lockOrder, checkoutMedical } from "@/api/order";
import { convertToTreeData } from '@/utils/constants';

class Page {
  total = 0;
  page = 1;
  limit = 10;
}

class Search {
  typepx = '';
  medical_id = "";
  kingdee_code = "";
  sale_id = "";
  status = 1;
  start_time = "";
  end_time = "";
  consignee = "";
  telephone = "";
  is_app = "";
  shop_name = "";
  low_total = "";
  large_total = "";
  business_type = "";
  order_type = "";
  display_cannel = 0;
}

class Options {
  pxTypeList = [];
  staff = [];
  typeList = [
    { id: 1, name: '品项' },
    { id: 2, name: '商品' },
    { id: 3, name: '服务' }
  ];
  goodsList = [];
  business_type = [
    { id: 1, name: "疤痕" },
    { id: 2, name: "项目" },
    { id: 3, name: "青春痘" },
    { id: 4, name: "护肤品" }
  ];
  order_type = [
    { id: 1, name: "新单" },
    { id: 2, name: "补单" }
  ];
  is_app_List = [
    { id: 0, name: "中台" },
    { id: 1, name: "小程序" }
  ];
  display_cannel = [
    { id: 1, name: "未作废" },
    { id: 4, name: "已作废" }
  ];
}

export default {
  name: "OrderList",
  mixins: [dateMixin],
  components: {
    pagination
  },
  props: {
    clienId: {
      type: String,
      default: ""
    },
    detail: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      fullscreenLoading: false,
      table_loading: false,
      search: new Search(),
      options: new Options(),
      page: new Page(),
      list: [],
      flatList: [],
      idList: "",
      oldId: "",
      value1: [],
      sum_amount: "noShow",
      is_show_add: true,
      orderSpanMap: {}
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  mounted() {
    this.search.medical_id = this.$route.query.medical_id || ''
    if (this.clienId) {
      this.getcheck()
      this.oldId = this.$route.query.id.toString()
    } else {
      this.setDefaultDate();
    }
    this.getList();
    this.getGoods();
  },
  methods: {
    getcheck(){
      checkoutMedical({
        customer_id: this.clienId
      }).then(res => {
        this.is_show_add = res.data
      })
    },
    // 构建订单合并映射
    buildOrderSpanMap(flatData) {
      const map = {};
      let currentOrderId = null;
      let startIndex = 0;
      
      flatData.forEach((item, index) => {
        const orderId = item.id;
        if (orderId !== currentOrderId) {
          if (currentOrderId !== null) {
            map[currentOrderId] = {
              start: startIndex,
              end: index - 1,
              count: index - startIndex
            };
          }
          currentOrderId = orderId;
          startIndex = index;
        }
      });
      
      if (currentOrderId !== null && flatData.length > 0) {
        map[currentOrderId] = {
          start: startIndex,
          end: flatData.length - 1,
          count: flatData.length - startIndex
        };
      }
      
      return map;
    },

    // 合并单元格方法
// 合并单元格方法
spanMethod({ row, column, rowIndex, columnIndex }) {
  // 需要合并的列索引
  // 0:订单编号, 1:成交日期, 2:客户名称, 3:手机号, 4:客户K3代码, 
  // 5:门店, 6:开单人, 7:订单来源, 8:订单类型,
  // 9:标准单价, 10:标准金额, 11:销售金额, 12:实付金额, 13:优惠后本金,
  // 14:优惠后赠金, 15:优惠后店转, 16:订单状态, 17:所属病历ID,
  // 21:业务类型, 25:操作
  const mergeColumns = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 28];
  
  if (!mergeColumns.includes(columnIndex)) {
    return [1, 1];
  }
  
  const orderId = row.id;
  const spanInfo = this.orderSpanMap[orderId];
  
  if (!spanInfo) {
    return [1, 1];
  }
  
  const { start, count } = spanInfo;
  
  if (rowIndex === start) {
    return [count, 1];
  }
  
  return [0, 0];
},

    // 展平订单数据
    flattenOrderList(orderList) {
      const result = [];
      orderList.forEach(order => {
        if (order.goods_list && order.goods_list.length > 0) {
          order.goods_list.forEach((goods, index) => {
            result.push({
              id: order.id,
              order_no: order.order_no,
              deal_time: order.deal_time,
              consignee: order.consignee,
              telephone: order.telephone,
              king_no: order.king_no,
              shop_name: order.shop_name,
              sale_name: order.sale_name,
              is_app_msg: order.is_app_msg,
              business_type: order.business_type,
              order_type: order.order_type,
              order_amount: order.order_amount,
              after_discount_amount: order.after_discount_amount,
              pay_amount: order.pay_amount,
              gift_amount: order.gift_amount,
              shop_transfer_amount: order.shop_transfer_amount,
              prestock_type: order.prestock_type,
              takeout_stock_num: order.takeout_stock_num,
              status_msg: order.status_msg,
              medical_id: order.medical_id,
              data_business_type: order.data_business_type || goods.data_business_type,
              type_one_name: order.type_one_name || goods.type_one_name,
              type_two_name: order.type_two_name || goods.type_two_name,
              type_three_name: order.type_three_name || goods.type_three_name,
              goods_list: order.goods_list,
              goods_name: goods.goods_name || goods.name || '-',
              goods_price: goods.goods_price || goods.price || 0,
              pay_price: goods.pay_price || 
              goods.discount_price || 0,
              shop_transfer_amount1: goods.shop_transfer_amount,
              gift_amount1: goods.gift_amount,
              pay_amount1: goods.pay_amount,
              number: goods.number || 1,
              goods_alias_name: goods.goods_alias_name || goods.alias_name || '-',
              after_discount_total: goods.after_discount_total || (goods.pay_price || goods.discount_price || 0) * (goods.number || 1),
              _rowKey: order.id + '_' + (goods.id || index)
            });
          });
        } else {
          result.push({
            ...order,
            goods_name: '-',
            goods_price: '-',
            pay_price: '-',
            number: '-',
            goods_alias_name: '-',
            after_discount_total: '-',
            _rowKey: order.id + '_empty'
          });
        }
      });
      return result;
    },

    handleTypeChange(val) {
      this.search.kingdee_code = ""
      if (val == 1) {
        this.remotePxMethod('');
      } else if (val == 2) {
        this.remoteSpMethod('');
      } else if (val == 3) {
        this.remoteFwMethod('');
      }
    },

    remoteMethodGoods(query) {
      if (this.search.type == 1) {
        this.remotePxMethod(query);
      } else if (this.search.type == 2) {
        this.remoteSpMethod(query);
      } else if (this.search.type == 3) {
        this.remoteFwMethod(query);
      }
    },

    remoteSpMethod(query) {
      getGoodList({ type: 2, action: 'search', name: query }).then(res => {
        this.options.goodsList = res;
      })
    },

    remoteFwMethod(query) {
      getGoodList({ type: 3, action: 'search', name: query }).then(res => {
        this.options.goodsList = res;
      })
    },

    remotePxMethod(query) {
      getGoodList({ type: 1, shop_id: this.userInfo.shop_id, name: query, action: 'search' }).then(res => {
        this.options.goodsList = res;
      })
    },

    getGoods() {
      searchPersonList().then(res => {
        this.options.staff = res
      })
      getProductTypeParent({ level: 'three' }).then(res => {
        this.options.pxTypeList = convertToTreeData(res.data);
      })
    },

    getList(option) {
      this.table_loading = true
      if (option == "search") this.page = new Page();
      orderList({
        ...this.search,
        type_one: this.search.typepx[0] || '',
        type_two: this.search.typepx[1] || '',
        type_three: this.search.typepx[2] || '',
        ...this.page,
        uid: this.clienId ? this.clienId : "",
      }).then(res => {
        this.table_loading = false
        this.list = res.list || [];
        this.flatList = this.flattenOrderList(this.list);
        this.orderSpanMap = this.buildOrderSpanMap(this.flatList);
        this.page.total = res.dataCount || 0;
        if (this.search.end_time) {
          this.sum_amount = res.sum_amount;
        } else {
          this.sum_amount = "noShow";
        }
      }).catch(() => {
        this.table_loading = false
      });
    },

    searchTime(val) {
      if (val) {
        this.search.start_time = val[0];
        this.search.end_time = val[1];
      } else {
        this.search.start_time = "";
        this.search.end_time = "";
      }
    },

    tapDetail(type, row) {
      console.log(type, "444");
      switch (type) {
        case "销售出库单详情":
          this.$router.push(
            `./orderDetail?id=${row.id}&type=order${row.medical_id ? `&medical_id=${row.medical_id}` : ''}`
          );
          break;
        case "销售记录详情":
          const queryD = { id: row.id, clienId: this.clienId, detail: this.detail, activeName: "second1", activeTab: 'salesRecords', medical_id: String(row.medical_id) || '' };
          this.$router.push({ name: "销售出库单详情", query: queryD });
          break;
        case "add":
          const query = { clienId: this.clienId, detail: this.detail };
          this.$router.push({ name: "创建订单", query });
          break;
        case "export":
          this.hint("导出选中列表", "export");
          break;
        case "lock":
          if (this.search.end_time) {
            this.hint("锁定选中条件的订单", "lock");
          } else {
            this.$message({
              message: "请选择锁定日期",
              type: "warning"
            });
          }
          break;
      }
    },

    hint(text, type) {
      this.$confirm(`${text},是否确定？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (type == "export") {
            this.getExport();
          } else {
            this.getLockOrder();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },

    getLockOrder() {
      lockOrder({ ...this.search }).then(res => {
        this.$message({
          message: res.msg,
          type: "success"
        });
        this.getList();
      });
    },

    getExport() {
      this.fullscreenLoading = true
      exportOrder({
        ...this.search,
        type_one: this.search.typepx[0] || '',
        type_two: this.search.typepx[1] || '',
        type_three: this.search.typepx[2] || '',
        uid: this.clienId ? this.clienId : "",
      }).then(res => {
        this.fullscreenLoading = false
        window.open(res.data.url);
      }).catch((err) => {
        console.log(err)
        this.fullscreenLoading = false
      })
    },

    handleSelectionChange(val) {
      this.idList = val.map(i => {
        return i.id;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.bgW {
  background: #fff;
  border-radius: 3px;
  margin-bottom: 20px;
}
.el-form-item {
  margin: 5px 10px 3px 0;
}
.accountCon {
  background: #fff;
  padding: 10px 0px 80px;
}
.reveal {
  text-align: right;
  padding: 20px 0;
  .peril {
    font-weight: bold;
  }
}
.btnBox {
  display: flex;
  column-gap: 10px;
}
.theme {
  cursor: pointer;
}
.theme:hover {
  text-decoration: underline;
}
</style>